<template>
<div id="roleManage"></div>
</template>

<script>
export default {
  name: 'roleManage'
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/roleAndPermission/roleManage/index.vue